import { Box, Typography } from '@mui/material';
import React from 'react';

interface Props {
  info: string;
}

const styles = {
  typo: {
    fontFamily: 'Nexa',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '16px',
    background:
      'linear-gradient(179.4deg, #01ACA4 -21.28%, #1D3557 72.79%, #190E1F 100.33%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
} as const;

export function AppNoFeedback({ info }: Props): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        mt: 3,
      }}
    >
      <Typography variant="subtitle1" sx={styles.typo}>
        No {info} yet
      </Typography>
    </Box>
  );
}
